import { del, put, get, post } from 'redux/lib/api';

export const getMonitors = () => {
  return get('http/jobs', {
    action: 'GET_MONITORS',
    query: {
      limit: 10,
      offset: 0,
    },
  });
};

export const getMoreMonitors = ({ limit, offset }) => {
  return get('http/jobs', {
    action: 'GET_MORE_MONITORS',
    query: {
      limit,
      offset,
    },
  });
};

export const searchMonitors = ({ text }) => {
  return get('http/jobs', {
    action: 'SEARCH_MONITORS',
    query: {
      text,
    },
  });
};

export const getRecentMonitorChecksByJobId = ({ jobId }) => {
  return get(`http/job/${jobId}/recent`, {
    action: 'GET_MONITOR_CHECKS',
    meta: {
      jobId,
    },
  });
};

export const getMonitorDataByJobId = (jobId) => {
  return get(`http/job/${jobId}`, {
    action: 'GET_HTTP_MONITOR_DATA',
    meta: {
      jobId,
    },
  });
};

export const postMonitor = (data, callback) => {
  // Determine if this is a 30-second interval check
  const isThirtySecondCheck = data?.run_interval_seconds === 0.5;
  
  return post(`http/job`, {
    data: {
      friendly_name: data.friendly_name,
      check_regions: data.check_regions,
      min_healthy_regions: data.min_healthy_regions,
      method: data.method || 'GET',
      uri: data.uri,
      request_body: data.request_body,
      content_type: data.content_type === 'none' ? null : data.content_type,
      auth_type: data.auth_type === 'none' ? null : data.auth_type,
      auth_username: data.auth_username,
      auth_password: data.auth_password,
      auth_bearer_token: data.auth_bearer_token,
      timeout_ms: parseFloat(data?.timeout_ms || 15) * 1000,
      // For 30s checks, send 60 seconds but flag as thirty_seconds
      run_interval_seconds: isThirtySecondCheck ? 60 : data?.run_interval_seconds * 60,
      run_interval_thirty_seconds: isThirtySecondCheck,
      group_notification_ids: data?.group_notification_ids || [],
      custom_http_headers: data.custom_http_headers || {},
      state: data?.state,
      keyword_search: data?.keyword_search,
      keyword_search_inverted: data.keyword_search_inverted,
      keyword_search_case_sensitive: data.keyword_search_case_sensitive,
      keyword_search_regex: data.keyword_search_regex,
      monitor_tls: data?.monitor_tls,
      monitor_dns: data?.monitor_dns,
      tags: data?.tags,
      success_http_codes: data?.success_http_codes,
      failure_http_codes: data?.failure_http_codes,
    },
    action: 'CREATE_HTTP_MONITOR',
    callback,
  });
};

export const deleteMonitor = (id, callback) => {
  return del(`http/job/${id}`, {
    action: 'DELETE_HTTP_MONITOR',
    onResponse: () => {
      return {
        status: 200,
        data: {
          job_id: id,
        },
      };
    },
    callback,
  });
};

export const putMonitor = (id, data, callback) => {
  // Determine if this is a 30-second interval check
  const isThirtySecondCheck = data?.run_interval_seconds === 0.5;
  
  return put(`http/job/${id}`, {
    data: {
      friendly_name: data.friendly_name,
      check_regions: data.check_regions,
      min_healthy_regions: data.min_healthy_regions,
      method: data.method || 'GET',
      uri: data.uri,
      request_body: data.request_body,
      content_type: data.content_type === 'none' ? null : data.content_type,
      auth_type: data.auth_type === 'none' ? null : data.auth_type,
      auth_username: data.auth_username,
      auth_password: data.auth_password,
      auth_bearer_token: data.auth_bearer_token,
      timeout_ms: parseFloat(data?.timeout_ms || 15) * 1000,
      // For 30s checks, send 60 seconds but flag as thirty_seconds
      run_interval_seconds: isThirtySecondCheck ? 60 : data?.run_interval_seconds * 60,
      run_interval_thirty_seconds: isThirtySecondCheck,
      group_notification_ids: data?.group_notification_ids,
      custom_http_headers: data.custom_http_headers || {},
      state: data?.state,
      keyword_search: data?.keyword_search,
      keyword_search_inverted: data.keyword_search_inverted,
      keyword_search_case_sensitive: data.keyword_search_case_sensitive,
      keyword_search_regex: data.keyword_search_regex,
      monitor_tls: data?.monitor_tls,
      monitor_dns: data?.monitor_dns,
      tags: data?.tags,
      success_http_codes: data?.success_http_codes,
      failure_http_codes: data?.failure_http_codes,
    },
    action: 'UPSERT_HTTP_MONITOR',
    callback,
  });
};

export const getMonitorEvents = ({ jobId }) => {
  return get(`http/job/${jobId}/events`, {
    action: 'GET_MONITOR_EVENTS',
    meta: {
      jobId,
    },
  });
};

export const getMonitorEventDetails = ({ eventId }) => {
  return get(`http/job/result/${eventId}/details`, {
    action: 'GET_MONITOR_EVENT_DETAILS',
    meta: {
      eventId,
    },
  });
};

export const getTlsState = (tls_job_id) => {
  return get(`tls/job/${tls_job_id}`, {
    action: 'GET_TLS_STATE',
  });
};

export const getDnsState = (tls_job_id) => {
  return get(`dns/job/${tls_job_id}`, {
    action: 'GET_DNS_STATE',
  });
};

export const getSiteUptime = ({ job_id, startDate, endDate }) => {
  return get(`http/job/${job_id}/uptime_percentage`, {
    action: 'GET_SITE_UPTIME',
    query: {
      start_date_time: startDate,
      end_date_time: endDate,
    },
  });
};

export const getPerformanceData = ({ job_id, timeFrame }) => {
  return get(`http/job/${job_id}/performance`, {
    action: 'GET_PERFORMANCE_DATA',
    query: {
      time_frame: timeFrame,
    },
  });
};
